// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fc-qW","colBig":"styles_colBig__1lRWN","colSmall":"styles_colSmall__3oRM0","shopifyNameWrapper":"styles_shopifyNameWrapper__JYrns"};